
















import { Cadastros } from "@/services/dashboard.service";
import Vue from 'vue';
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({
  
})

export default class GraficoLegenda extends Vue{
  valoresLegendas = {
    app: 0,
    web: 0,
  };

  @Prop() readonly value!: Cadastros[];
  @Prop() readonly date!: string | null | Date;
  @Prop() readonly diario!: boolean;

  @Watch("value")
  onValueChange() {
    const source = this.value ?? [];

    if(this.diario){
      this.valoresLegendas.app =
        source.length > 0
          ? source.find(x => x.data === this.date)?.quantidadeApp! : 0;

      this.valoresLegendas.web =
        source.length > 0
          ? source.find(x => x.data === this.date)?.quantidadeSite! : 0;
    }
    else{
      this.valoresLegendas.app = source.length > 0 ? source.map((x) => x.quantidadeApp ?? 0).reduce((a, b) => a + b) : 0;
      this.valoresLegendas.web = source.length > 0 ? source.map((x) => x.quantidadeSite ?? 0).reduce((a, b) => a + b) : 0;
    }
    
  }

  mounted() {
    this.onValueChange();
  }
}
